module.exports = __webpack_public_path__ + "static/media/cookie3.4bee6ca8.png";